import * as mocks from '../../mocks/notification';

class MockNotificationRepository {
    
    sendEmail(mailInfo){
        return Promise.resolve(mocks.sendEmail(mailInfo));
        
    }
}
export default MockNotificationRepository;